import { defineStore } from "pinia";
import axios from "axios";

const isTruthySuperadmin = (value) => {
  return value === true || value === 1 || value === "1";
};

const getPermissionCodes = (permissions = []) => {
  return permissions
    .map((permission) => permission.code)
    .filter(Boolean);
};

export const useUserStore = defineStore("user", {
  state: () => ({
    data: null,
  }),

  getters: {
    user: (state) => {
      return state.data;
    },

    isLoaded: (state) => {
      return Boolean(state.data);
    },

    permissions: (state) => {
      return state.data?.permissions || [];
    },

    permissionCodes: (state) => {
      return getPermissionCodes(state.data?.permissions || []);
    },

    // Mantém disponível, mas NÃO é usado para liberar permissões
    isSuperadmin: (state) => {
      return isTruthySuperadmin(state.data?.superadmin);
    },

    hasPermission: (state) => {
      return (permissionCode) => {
        const userPermissionCodes = getPermissionCodes(
          state.data?.permissions || []
        );

        return userPermissionCodes.includes(permissionCode);
      };
    },

    hasAnyPermission: (state) => {
      return (requiredPermissions = []) => {
        const userPermissionCodes = getPermissionCodes(
          state.data?.permissions || []
        );

        return requiredPermissions.some((requiredPermission) => {
          return userPermissionCodes.includes(requiredPermission);
        });
      };
    },

    hasAllPermissions: (state) => {
      return (requiredPermissions = []) => {
        const userPermissionCodes = getPermissionCodes(
          state.data?.permissions || []
        );

        return requiredPermissions.every((requiredPermission) => {
          return userPermissionCodes.includes(requiredPermission);
        });
      };
    },
  },

  actions: {
    async getUser() {
      try {
        const { data } = await axios.get("/api/auth/me");
        if (!data.success) {
          throw new Error("Error fetching user data.");
        }
        this.data = data.data;
        return this.data;
      } catch (err) {
        this.clearUser();
        return null;
      }
    },

    clearUser() {
      this.data = null;
    },
  },
});
